import Resize from '@/mixins/Resize'
import Scene from './anim/Scene'
import { Tween } from '../../pure/Timeline'

export default
{
    mixins: [
        Resize
    ],

    props:
    {
        color: { type: String },
        pageNum: { type: Number, default: 0 }
    },

    watch:
    {
        pageNum: 'changeColor'
    },

    mounted()
    {
        this.scene = new Scene(this.$el)
        this.scene.resize(this.resize.width, this.resize.height)

        this.changeColor()
    },

    beforeDestroy()
    {
        cancelAnimationFrame(this.raf)
    },

    methods:
    {
        changeColor()
        {
            if (this.lastState === undefined)
            {
                this.lastState = Scene.STATE_START
            }
            else
            {
                this.lastState = this.state
            }

            switch (this.color)
            {
                case 'light' :
                    this.state = Scene.STATE_WHITE
                    break
                case 'dark' :
                    this.state = Scene.STATE_DARK
                    break
                case 'blue' :
                    this.state = Scene.STATE_BLUE
                    break
                default:
                    throw new Error('The color ' + this.color + ' don\'nt exist')
            }

            if (this.tween)
            {
                this.tween.remove()
                delete this.tween
            }

            this.tween = new Tween({ from: 0, to: 1, duration: 2000, easing: [.5, 0, .4, 1] })
                .onChange(val => this.scene.render(this.lastState, this.state, val, this.pageNum))
                .onEnd(() => delete this.tween)
        },

        onResized(width, height)
        {
            this.scene.resize(width, height)
        }
    }
}
